import { test } from 'ramda';
import { createSelector } from 'reselect';

export const getPathname = state => state.router.location.pathname;

const censusViewPagePattern = /(^\/map|^\/chart|^\/table)\/(\d+)/;

export const getSelectedCityId = createSelector(getPathname, pathname => {
  const match = pathname.match(censusViewPagePattern);
  return match ? match[2] : null;
});

export const isCensusView = createSelector(
  getPathname,
  test(censusViewPagePattern),
);



// WEBPACK FOOTER //
// ./src/selectors/router.js